"use client"

import clsx from "clsx"
import { Accessory } from "src/components/cart/Accessory"
import { CarouselArrow } from "src/components/generic/CarouselArrow"
import { PaginationDots } from "src/components/generic/PaginationDots"
import { useEventCallback } from "src/components/hooks/useEventCallback"
import { ResolvedAccessoryProductData } from "src/data/product-accessories-resolved/types"
import { useEmbla } from "src/utilities/embla"

export type AccessoriesCarouselProps = {
  accessories: ResolvedAccessoryProductData[]
}

export const AccessoriesCarousel = ({ accessories }: AccessoriesCarouselProps) => {
  const { ref, embla, hasPrev, hasNext, scrollSnaps, activeIndex, justifyCenter } = useEmbla({
    align: "start",
  })

  const onPrevClick = useEventCallback(() => embla?.scrollPrev())
  const onNextClick = useEventCallback(() => embla?.scrollNext())

  return (
    <section className="embla relative flex w-full flex-col gap-6">
      <div
        ref={ref}
        className={clsx("embla__viewport overflow-hidden", {
          "cursor-grab active:cursor-grabbing": hasPrev || hasNext,
        })}
      >
        <div
          className={clsx("embla__container flex max-h-full", {
            "justify-center": justifyCenter,
          })}
        >
          {accessories.map((accessory, index) => {
            return (
              <div key={index} className="embla__slide max-h-full min-w-0 shrink-0 grow-0 basis-36 pl-6">
                <Accessory key={accessory.slug} accessory={accessory} />
              </div>
            )
          })}
        </div>
      </div>

      {(hasPrev || hasNext) && (
        <div className="hidden justify-center gap-2 p-6 md:flex">
          {hasPrev && <CarouselArrow side="left" onClick={onPrevClick} />}
          {hasNext && <CarouselArrow side="right" onClick={onNextClick} />}
        </div>
      )}

      {!justifyCenter && (
        <div className="flex justify-center py-6 md:hidden">
          <PaginationDots count={scrollSnaps.length} activeIndex={activeIndex} />
        </div>
      )}
    </section>
  )
}
